module.exports = __webpack_public_path__ + "img/logoBlack2.f405f362.svg";